<template>
  <div class="overlay" @click="cancelClick">
    <div class="overlay_inner channel_list" @click.stop>
      <app-button-delete @click="cancelClick" class="btn_close"/>
      <app-input
            :label="translations.search"
            name="search"
            type="search"
            v-model="search"
      />
      <p class="note">
        {{ getDeleteMessage() }}
      </p>
      <div class="format-tags" v-if="item.type === 'LABEL_TYPE_FORMAT'">
        <ul>
          <li v-for="label in formatLabels">
            <app-radio-button
                    :name="label.labelName"
                    :key="label._id"
                    :title="label.labelName"
                    v-model="formatLabelId"
                    :value="label._id"
            />
          </li>
        </ul>
      </div>
      <div class="content-tags" v-if="item.type === 'LABEL_TYPE_CONTENT'">
        <ul>
          <app-checkbox
            v-for="label in contentLabels"
            list
            :title="label.labelName"
            :key="label._id"
            :form-value="label._id"
            v-model="label.checked"
            name="label.labelName"
          />
        </ul>
      </div>
      <p class="buttons">
        <app-button class="btn_deleteconfirm" @click="submitClick" v-translate>
          POTVRDIT A SMAZAT
        </app-button>
      </p>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'app-delete-label-dialog',
    props: {
      item: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        labels: [],
        formatLabelId: null,
        search: ''
      }
    },
    created() {
        this.getLabelsFullList({params: {
            idLanguage: this.$store.state.uiLanguages.currentLanguageId,
            limit: 1000,
        }}).then((response) => {
            this.labels = response.data.data;
        });
    },
    computed: {
      translations() {
        return {
          emptyLabels: this.$gettext("Vyberte alespoň jeden štítek, nebo možnost 'žádný'"),
          empty: this.$gettext("Žádný")
        }
      },
      formatLabels() {
        let item = this.item
        return this.labels.filter(function(e) {
          return (e._id !== item._id && e.type === 'LABEL_TYPE_FORMAT' && e.labelName.toUpperCase().
          includes(this.search.trim().toUpperCase()))
        }.bind(this)).sort(this.sortByLabelNames).concat([{
          labelName: this.translations.empty,
          _id: -1
        }])
      },
      contentLabels() {
        const item = this.item
        return this.labels.filter(function(e) {
          e.checked = false
          return (e._id !== item._id && e.type === 'LABEL_TYPE_CONTENT' && e.labelName.toUpperCase().
          includes(this.search.trim().toUpperCase()))
        }.bind(this)).sort(this.sortByLabelNames)
      }
    },
    methods: {
      ...mapActions([
        'getLabelsFullList',
        'appShowErrors',
        'deleteLabel'
      ]),
      getDeleteMessage() {
        return this.$gettext('Na štítek "') + this.item.labelName + this.$gettext('" je navázáno ') + this.item.numberOfShows +
                this.$gettext(' pořadů a ' + this.item.numberOfBroadcasts + ' vysílání! Výběrem níže můžete štítek nahradit')
      },
      sortByLabelNames(a, b) {
          if (a.labelName > b.labelName) {
              return 1
          } else if (a.labelName < b.labelName) {
              return -1
          } else {
              return 0
          }
      },
      async submitClick() {
        let labels = ""
        if (this.item.type === "LABEL_TYPE_FORMAT") {
          if (!this.formatLabelId) {
            this.appShowErrors([this.translations.emptyLabels])
            return
          } else {
            if (this.formatLabelId !== -1) {
              labels = "/" + this.formatLabelId.toString()
            }
          }
        }
        if (this.item.type === "LABEL_TYPE_CONTENT") {
          const arr = this.contentLabels.filter(function(e) {
            return e.checked === true
          }).map(v => v._id)
          if (arr.length > 0) {
            labels = "/" + arr.join(',')
          }
        }
        this.deleteLabel({
          params: {
            id: this.item._id,
            labelIds: labels
          }
        })
        this.$emit('refreshDeletedItem')
        this.$router.push({
          name: 'labels'
        })
      },
      cancelClick() {
        this.$emit('refreshDeletedItem')
      }
    }
  }
</script>
